import { getItem, setItem } from './storage';

const SYNC_QUEUE_KEY = 'sync_queue';

export const addToSyncQueue = async (action) => {
  const queue = (await getItem(SYNC_QUEUE_KEY)) || [];
  queue.push(action);
  await setItem(SYNC_QUEUE_KEY, queue);
};

export const getSyncQueue = async () => {
  return (await getItem(SYNC_QUEUE_KEY)) || [];
};

export const clearSyncQueue = async () => {
  await setItem(SYNC_QUEUE_KEY, []);
};

// Example: sync reading progress when online
export const syncProgress = async (bookId, page) => {
  // add to queue
  await addToSyncQueue({ type: 'progress', bookId, page, timestamp: Date.now() });
  // then attempt to send if online (handled elsewhere)
};

export const sendSyncQueue = async (apiClient) => {
  const queue = await getSyncQueue();
  if (queue.length === 0) return;
  try {
    for (const item of queue) {
      if (item.type === 'progress') {
        await apiClient.post('/books/progress', { bookId: item.bookId, page: item.page });
      }
      // other types...
    }
    await clearSyncQueue();
  } catch (e) {
    console.error('Sync failed, will retry later:', e);
  }
};